// fruits
import hapalas from "../../assets/images/fruits/hapalas2.webp";
import orange from "../../assets/images/fruits/orange.webp";
import grape from "../../assets/images/fruits/grape.webp";
import malina from "../../assets/images/fruits/malina.webp";
import mango from "../../assets/images/fruits/MANGO_1.webp";
import pomegranate from "../../assets/images/fruits/pomegranate.webp";
import pashion from "../../assets/images/fruits/pashion.webp";
import banana from "../../assets/images/fruits/banana.webp";

export const floatingItems = [
  // ----- FRUITS (как были, можно оставить size по умолчанию) -----
  {
    src: mango,
    alt: "Mango",
    style: {
      "--start-top": "70%",
      "--start-left": "10%",
      "--tx": "-90vw",
      "--ty": "00vh",
    },
    size: "28vmin",
  },
  {
    src: malina,
    alt: "Malina",
    style: {
      "--start-top": "20%",
      "--start-left": "20%",
      "--tx": "-30vw",
      "--ty": "-15vh",
    },
    size: "36vmin",
  },
  {
    src: orange,
    alt: "Orange",
    style: {
      "--start-top": "20%",
      "--start-left": "80%",
      "--tx": "25vw",
      "--ty": "-20vh",
    },
    size: "25vmin",
  },
  {
    src: grape,
    alt: "Grape",
    style: {
      "--start-top": "70%",
      "--start-left": "80%",
      "--tx": "30vw",
      "--ty": "25vh",
    },
    size: "30vmin",
  },
  {
    src: pomegranate,
    alt: "Pomegranate",
    style: {
      "--start-top": "50%",
      "--start-left": "95%",
      "--tx": "20vw",
      "--ty": "0vh",
    },
    size: "27vmin",
  },
];

export const fruits = [
  {
    id: 1,
    src: mango,
    alt: "Mango",
    top: "44%",
    left: "27%",
    size: "12%",
    zIndex: 999,
  },

  {
    id: 2,
    src: hapalas,
    alt: "Hapalas",
    top: "7%",
    left: "76%",
    size: "8%",
    zIndex: 999,
  },
  {
    id: 3,
    src: malina,
    alt: "Malina",
    top: "-3%",
    left: "14%",
    size: "12%",
    zIndex: 999,
  },
  {
    id: 4,
    src: grape,
    alt: "grape",
    top: "48%",
    left: "75%",
    size: "11%",
  },
  {
    id: 5,
    src: pomegranate,
    alt: "pomegranate",
    top: "37%",
    left: "45%",
    size: "14%",
    zIndex: 999,
  },
  {
    id: 6,
    src: pashion,
    alt: "pashion",
    top: "8%",
    left: "58%",
    size: "11%",
    zIndex: 999,
  },

  {
    id: 7,
    src: banana,
    alt: "banana",
    top: "-4%",
    left: "40%",
    size: "12%",
    zIndex: 999,
  },
];
